module.exports = __webpack_public_path__ + "img/dwpost.6486cf1f.png";